import styled from 'styled-components/macro'

export const EmptyFieldStyled = styled.div`
  @media (max-width: 768px) {
    display: none;
  }
`
